import { NOTIFICATION_THEME_VALUES } from './notificationThemeValues';

export const notificationTheme = {
  inputColumnSize: NOTIFICATION_THEME_VALUES.INPUT_COL_SIZE,
  templateColumnSize:
    NOTIFICATION_THEME_VALUES.COL_MAX_SIZE -
    NOTIFICATION_THEME_VALUES.INPUT_COL_SIZE,
};
